import React from 'react';
import './PageNotFound.css'
const PageNotFound = () => {
    return (
        <div className='text-center my-5'>
            <h1>404</h1>
            <h3>OOPPS!! Page Not Found</h3>
        </div>
    );
};

export default PageNotFound;